import React from 'react';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  Button, 
  Box 
} from '@mui/material';

const ErrorDialog = ({ open, setOpen, message, themeColors }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': {
          width: { xs: '90%', sm: 'auto' },
          maxWidth: { xs: '90%', sm: '500px' }
        }
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ bgcolor: themeColors.primary, color: 'white' }}>
        <Box display="flex" alignItems="center">
          <Box component="span" mr={1}>⚠️</Box>
          Required Fields
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ pt: 2 }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => setOpen(false)} 
          autoFocus
          variant="contained"
          sx={{ 
            bgcolor: themeColors.primary, 
            color: 'white',
            '&:hover': {
              bgcolor: themeColors.primaryLight,
            }
          }}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;